import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgSearch = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.3 2.4C4.5938 2.4 2.4 4.5938 2.4 7.3C2.4 10.0062 4.5938 12.2 7.3 12.2C8.62016 12.2 9.81839 11.6779 10.6995 10.829C10.7179 10.805 10.7381 10.782 10.76 10.76C10.782 10.7381 10.805 10.7179 10.829 10.6995C11.6779 9.81839 12.2 8.62016 12.2 7.3C12.2 4.5938 10.0062 2.4 7.3 2.4ZM12.2223 11.2324C13.0845 10.1546 13.6 8.78751 13.6 7.3C13.6 3.82061 10.7794 1 7.3 1C3.82061 1 1 3.82061 1 7.3C1 10.7794 3.82061 13.6 7.3 13.6C8.78751 13.6 10.1546 13.0845 11.2324 12.2223L13.805 14.795C14.0784 15.0683 14.5216 15.0683 14.795 14.795C15.0683 14.5216 15.0683 14.0784 14.795 13.805L12.2223 11.2324Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgSearch)
const IconSvgSearch = createIcon(ForwardRef, 'SvgSearch')
export default IconSvgSearch
